import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiDefectsService {
  baseURL: string;

  constructor(private authService: AuthService, private http: HttpClient) {
    if (window.location.href.includes('localhost')) {
      this.baseURL = 'http://localhost';
    } else {
      // when is deployed
      this.baseURL = `${environment.url}`;
    }
  }

  ///api/tenant/task/defects/{tenantId}/{taskId}/list
  getTaskDefects(params: any) {
    const endpoint = `/api/wm/defects/task/${params.taskId}/list`;
    return this.http.get(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }
  //api/tenant/task/defects/files/{tenantId}/{taskDefectsId}/list
  getDefectAttachments(params: any) {
    const endpoint = `/api/wm/defects/files/defects/${params.defectId}/list`;
    return this.http.get(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.tenantId)
    });
  }

  deleteDefect(params: any) {
    //api/tenant/task/defects/{tenantId}/{taskDefectsId}
    const endpoint = `/api/wm/defects/${params.taskId}/delete`;
    return this.http.delete(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }

  //task/defects/{tenantId}/{taskId}/create
  createManualDefect(params: any) {
    const endpoint = `/api/wm/defects/task/${params.taskId}/create`;
    return this.http.post(this.baseURL + endpoint, params.body, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }
  ///api/tenant/task/defects/{tenantId}
  updateManualDefect(params: any) {
    const endpoint = `/api/wm/defects/task/defects/update`;
    return this.http.put(this.baseURL + endpoint, params.body, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }
}
